import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import * as moment from 'moment';
import * as _ from 'lodash';
import { MonthTemplateContext } from './month-template-context';

const monthsInYear = 12;

@Component({
    selector: 'cln-calendar-year-view',
    template: require('./calendar-year-view.component.html'),
    styles: [require('./calendar-year-view.component.less')],
})
export class CalendarYearViewComponent implements OnInit, OnChanges {
    @Input() monthTemplate: TemplateRef<MonthTemplateContext>;
    @Input() startDate: moment.Moment;
    @Input() selectedDate: moment.Moment;
    @Output() monthChange = new EventEmitter<moment.Moment>();

    viewDate: moment.Moment = moment();
    months: MonthTemplateContext[];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.startDate && changes.startDate.currentValue) {
            this.viewDate = this.startDate.clone();
            this.updateView();
        }
    }

    ngOnInit(): void {
        this.viewDate = this.startDate || moment();
        this.updateView();
    }

    onMonthClicked(context: MonthTemplateContext): void {
        this.monthChange.emit(context.date);
    }

    isSelected(date: moment.Moment): boolean {
        return this.selectedDate && this.selectedDate.isSame(date, 'day');
    }

    private updateView(): void {
        const firstDay = this.viewDate.clone().startOf('year');
        this.months = _.range(monthsInYear).map((monthIdx) => {
            const month = firstDay.clone().month(monthIdx);
            return <MonthTemplateContext> {
                monthName: month.format('MMM'),
                monthIndex: monthIdx,
                date: month,
            };
        });
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/calendar/calendar/calendar-year-view/calendar-year-view.component.ts